import { useState, useEffect } from 'react'
import { Modal, Button, Group } from '@mantine/core'
import { Cropper } from 'react-cropper'
import 'cropperjs/dist/cropper.css'

interface Props {
  file: File | null;
  open: boolean;
  onClose: () => void;
  onCrop: (blob: Blob) => Promise<void>;
  loading: boolean;
}

export default function PhotoUploadCropModal ({ file, open, onClose, onCrop, loading }: Props) {
  const [cropper, setCropper] = useState<Cropper>()
  const [preview, setPreview] = useState<string>('')

  useEffect(() => {
    if (file) {
      const url = URL.createObjectURL(file)
      setPreview(url)
      return () => URL.revokeObjectURL(url)
    } else {
      setPreview('')
    }
  }, [file])

  const handleCrop = async () => {
    if (!cropper) return
    // Explicitly encode as JPEG at 0.85 quality — avoids huge PNG output and ensures
    // a backend-accepted MIME type regardless of what the source file was (e.g. HEIC).
    cropper.getCroppedCanvas().toBlob(async (blob) => {
      if (blob) await onCrop(blob)
    }, 'image/jpeg', 0.85)
  }

  return (
    <Modal opened={open} onClose={onClose} title="Crop photo" size="lg">
      {preview && (
        <>
          <Cropper
            src={preview}
            style={{ height: 320, width: '100%' }}
            initialAspectRatio={1}
            aspectRatio={1}
            guides={false}
            viewMode={1}
            onInitialized={(c) => setCropper(c)}
          />
          <Group position="right" mt="md">
            <Button variant="default" onClick={onClose} disabled={loading}>
              Cancel
            </Button>
            <Button onClick={handleCrop} loading={loading}>
              Upload
            </Button>
          </Group>
        </>
      )}
    </Modal>
  )
}
